import React, { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import makeRequest from "../../utils/makeRequest";
import { isEmpty } from "lodash";
import "../../styles/index.css";

const AdminPage = () => {
  const [startDate, setStartDate] = useState(new Date());
  const [endDate, setEndDate] = useState(new Date());
  const [userId, setUserId] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [isMessage, setIsMessage] = useState(false);
  const [message, setMessage] = useState("");

  useEffect(() => {
    if (
      endDate >= startDate &&
      ((startDate !== null && endDate !== null) ||
        (startDate === null && endDate === null))
    ) {
      if (userId.length === 7 || userId.length === 0) {
        setIsActive(true);
        setIsMessage(false);
        setMessage("");
      } else {
        setIsActive(false);
        setIsMessage(false);
        setMessage("");
      }
    } else {
      setIsActive(false);
      setIsMessage(false);
      setMessage("");
    }
  }, [startDate, endDate, userId]);

  const download = (filename, text) => {
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/csv;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);
    element.style.display = "none";
    element.click();
  };
  const changeId = (event) => {
    let id = event.target.value;
    setUserId(id);
  };
  const fetchAdminReport = async () => {
    setIsMessage(true);
    const assessmentReport = await makeRequest(
      "post",
      `/api/events/AssessmentReport`,
      {
        userId: userId ? userId : null,
        startDate: startDate ? startDate : null,
        endDate: endDate ? endDate : null,
      }
    );
    if (assessmentReport && !isEmpty(assessmentReport)) {
      download("Kickoff_Assessment", assessmentReport);
      setMessage("Download complete");
    } else {
      setMessage("No Data available");
    }
  };
  return (
    <div>
      <div className="adminTitle">Admin Page</div>
      <table className="adminTable">
        <thead>
          <tr  className="adminTableTr">
            <th>S.No</th>
            <th>Report</th>
            <th>Start Date</th>
            <th>End Date</th>
            <th>PMI ID</th>
            <th>Action</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr className="adminTableTr">
            <td>1</td>
            <td>Assessment Report</td>
            <td>
              <DatePicker className="adminDateInput"
                dateFormat="yyyy-dd-MM"
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                maxDate={new Date()}
              />
            </td>
            <td>
              <DatePicker className="adminDateInput"
                dateFormat="yyyy-dd-MM"
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                maxDate={new Date()}
              />
            </td>
            <td>
              <form>
                <input className="adminDateInput"
                  type="number"
                  onChange={changeId}
                  placeholder="1234567"
                  maxLength="7"
                />
              </form>
            </td>
            <td>
              <button
                className={` ${
                  isActive ? "adminDownloadButton" : "adminDisableButton"
                }`}
                onClick={() => {
                  fetchAdminReport();
                }}
              >
                Download
              </button>
            </td>
            <td>
              <span className={` ${isMessage ? "adminMessage" : "adminDisableMessage"}`}>
                {message}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};
export default AdminPage;
